<template>
  <div>
  <h3 class="content-block openware-form-title">{{ title }}</h3>

    <DxPopup
        :drag-enabled="false"
        :hide-on-outside-click="true"
        :show-close-button="true"
        :show-title="true"

        :allow-column-reordering="true"
        :allow-column-resizing="true"
        :column-auto-width="true"
        :show-borders="true"
        :show-column-lines="true"
        :show-row-lines="true"
        :row-alternation-enabled="true"
        :focused-row-enabled="true"
        :title="title"
        :width="'90%'" 
        :height="'90%'"

        v-model:visible="isPopupVisible"
        titleTemplate="title"
        deferRendering="true"
        :animation="{
                        show: {
                            type: 'pop',
                            duration: 800,
                            from: {
                                scale: 0.90
                            }
                        }, 
                    }"
    >
        <DxScrollView height="100%" width="100%" ref="FormScrollViewRef">
            <AppointmentForm
                ref="appointmentForm"
                :appointment_id="selectedAppointmentID" 
                @closePopupEvent="onClosePopupEmit">
            </AppointmentForm>
        </DxScrollView>

    </DxPopup>

  <DxDataGrid
      ref="dataGrid"
      :key-expr="id"
      :data-source="CustomStoreMain"
      :allow-column-reordering="false"
      :allow-column-resizing="false"
      :column-hiding-enabled="false"
      :column-auto-width="true"
      :show-borders="true"
      :show-column-lines="true"
      :show-row-lines="true"
      :row-alternation-enabled="true"
      :focused-row-enabled="true"
      :word-wrap-enabled="true"
      :scrolling="{ mode: 'standard' }"
      
      :selection-filter="['appointments_frequency', '=', '3']"
      

      @exporting="onExporting"
      @cell-prepared="onCellPrepared"
  >

      <DxPaging 
          :enabled="true"
          :page-size="0"
      />

      <DxFilterRow :visible="true"/>

      <DxHeaderFilter :visible="true"/>

      <DxPager
          :visible="true"
          :allowed-page-sizes="pageSizes"
          :display-mode="displayMode"
          :show-page-size-selector="true"
          :show-info="true"
          :show-navigation-buttons="true"
      />

      <DxGroupPanel :visible="false"/>

      <DxSorting mode="multiple"/>

      <DxEditing
          :allow-updating="false"
          :allow-adding="false"
          :allow-deleting="false"

          :texts= "{
                      addRow: 'Προσθήκη',
                      deleteRow: 'Διαγραφή',
                      editRow:'Επεξεργασία',
                      saveAllChanges:'Αποθήκευση Όλων',
                      cancelAllChanges:'Ακύρωση Όλων'
                  }"
          mode="row"
      >
      </DxEditing>

      <DxToolbar>
            <DxItem location="after">
                <DxDateBox 
                    placeholder="Ημερομηνία"
                    :show-clear-button="true"
                    :use-mask-behavior="true"
                />
            </DxItem>
            
            <DxItem name="exportButton" 
                :options="{
                        hint: 'Εξαγωγή δεδομένων'
                    }"
            />
      </DxToolbar>

      <DxColumn
          data-field="appointment_year"
          caption="Έτος"
          :allow-grouping="true"
          :group-index="1"
          :hiding-priority="-1"
      >
      </DxColumn>

      <DxColumn
          data-field="client_type_name"
          caption="Τύπος Πελάτη"
          sort-order="asc"
          :hiding-priority="-1"
      >
      </DxColumn>

      <DxColumn caption="Εργασίες">
        <DxColumn
            data-field="count_appointments"
            caption="Πλήθος"
            data-type="number"
            :hiding-priority="-1"
        >
        </DxColumn>

        <DxColumn
            data-field="count_appointments_last_year"
            caption="Πλήθος Προηγ. Έτους"
            data-type="number"
            :hiding-priority="-1"
        >
        </DxColumn>

        <DxColumn
            data-field="diff_appointments_pcnt"
            caption="Διάφ. %"
            data-type="number"
            :hiding-priority="-1"
            :calculate-cell-value="calculateAppointmentsCellValue"
        >
        </DxColumn>
      </DxColumn>

      <DxColumn caption="Εισπρακτέα">
        <DxColumn
            data-field="sum_collected_amount"
            caption="Ποσό"
            data-type="number"
            :hiding-priority="-1"
            :format="formatCurrency"
        >
        </DxColumn>

        <DxColumn
            data-field="sum_collected_amount_last_year"
            caption="Ποσό Προηγ. Έτους"
            data-type="number"
            :hiding-priority="-1"
            :format="formatCurrency"
        >
        </DxColumn>

        <DxColumn
            data-field="diff_total_collected_value"
            caption="Διαφορά €"
            data-type="number"
            :hiding-priority="-1"
            :format="formatCurrency"
        >
        </DxColumn>

        <DxColumn
            data-field="diff_total_collected_pcnt"
            caption="Διάφ. %"
            data-type="number"
            :hiding-priority="-1"
            :calculate-cell-value="calculateCellValue"
        >
        </DxColumn>
      </DxColumn>

      <DxSummary>
          <DxGroupItem
              column="count_appointments"
              summary-type="sum"
              displayFormat="Σ: {0}"
              :align-by-column="true"
          />

          <DxGroupItem
              column="count_appointments_last_year"
              summary-type="sum"
              displayFormat="Σ: {0}"
              :align-by-column="true"
          />

          <DxGroupItem
              column="sum_collected_amount"
              summary-type="sum"
              :value-format="formatCurrency"
              displayFormat="Σ: {0}"
              :align-by-column="true"
          />

          <DxGroupItem
              column="sum_collected_amount_last_year"
              summary-type="sum"
              displayFormat="Σ: {0}"
              :value-format="formatCurrency"
              :align-by-column="true"
          />
          
          <DxGroupItem
              column="diff_total_collected_value"
              summary-type="sum"
              :value-format="formatCurrency"
              displayFormat="Σ: {0}"
              :align-by-column="true"
          />
          
          <DxTotalItem
              column="count_appointments"
              summary-type="sum"
              displayFormat="Σ: {0}"
          />

          <DxTotalItem
              column="count_appointments_last_year"
              summary-type="sum"
              displayFormat="Σ: {0}"
          />

          <DxTotalItem
              column="sum_collected_amount"
              summary-type="sum"
              :value-format="formatCurrency"
              displayFormat="Σ: {0}"
          />

          <DxTotalItem
              column="sum_collected_amount_last_year"
              summary-type="sum"
              :value-format="formatCurrency"
              displayFormat="Σ: {0}"
          />

          <DxTotalItem
              column="diff_total_collected_value"
              summary-type="sum"
              :value-format="formatCurrency"
              displayFormat="Σ: {0}"
          />

      </DxSummary>

      <!--
      <DxColumn 
            type="buttons">
                <DxButton 
                    text="Επεξεργασία"
                    icon="edit"
                    hint="Επεξεργασία"
                    :on-click="onCustomRowEdit"
                />
          >
      </DxColumn>

      <DxSelection
          mode="multiple"
      />
      -->

      <DxExport
          :enabled="true"
          :formats="['xlsx']"
          :texts= "{
                      exportAll: 'Εξαγωγή σε {0}',
                  }"
      />

  </DxDataGrid>

</div>

</template>

<script setup>
  import {
      DxDataGrid,
      DxColumn,
      DxEditing, 
      DxPaging, 
      DxPager,
      DxGroupPanel,
      DxSorting,
      DxFilterRow,
      DxHeaderFilter,
      DxExport,
      //DxLookup, //DxRemoteOperations, //DxRequiredRule,
      DxToolbar,
      DxItem,
      //DxButton,
      DxSummary,
      DxTotalItem,
      DxGroupItem
      //DxSelection
  } from 'devextreme-vue/data-grid'

  import 'whatwg-fetch'
  import CustomStore from 'devextreme/data/custom_store'

  //import DxSelectBox from 'devextreme-vue/select-box'

  //import { DxDateRangeBox } from 'devextreme-vue/date-range-box';
  //import DxDateBox from 'devextreme-vue/date-box';  
  
  import DxPopup from 'devextreme-vue/popup'
  import DxScrollView from 'devextreme-vue/scroll-view'
  import AppointmentForm from './ow-appointments-form.vue'
  
  //import DataSource from 'devextreme/data/data_source'

  import OParameters from '../es-globals';

  import { ref, /*reactive, computed, */ onMounted } from 'vue'

  //import { exportDataGrid } from 'devextreme/pdf_exporter';
  const dataGrid = ref(null)
  const FormScrollViewRef = ref(null)
  
  const title = 'Συγκεντρωτική Αναφορά Εργασιών ανά Έτος'
  const pageSizes = [5, 10, 20, 0]
  
  const selectedAppointmentID = ref(null)
  const isPopupVisible = ref(false)
  const formatCurrency = { 
            type: 'currency',
            currency: 'EUR', 
            useGrouping: true, 
            precision: 2 
        }

  const URL_SERVICE = OParameters.Host.URI + 'ow_view_rep_sales_yearly_summary'
  
  const CustomStoreMain = new CustomStore({
        key: 'appointment_id',

        load: () => sendRequest(URL_SERVICE),
        insert: (values) => sendRequest(URL_SERVICE, 'POST', values),
        update: (key, values) => sendRequest(URL_SERVICE + '/' + encodeURIComponent(key), 'PUT', values),
        remove: (key) => sendRequest(URL_SERVICE + '/' + encodeURIComponent(key), 'DELETE'),
        byKey: (key) => sendRequest(URL_SERVICE + "/" + encodeURIComponent(key)),
    })

    // 
    //  Based on: https://js.devexpress.com/Demos/WidgetsGallery/Demo/DataGrid/CRUDOperations/Vue/GreenMist/
    //
    const sendRequest = (url, method = 'GET', values = {}) => {
        // console.log('LOG: ' + url + ' METHOD: ' + method + ' VALUES: ' + JSON.stringify(values, null, 4));
        if (method === 'GET') {
            return fetch(url, {
                method,
                credentials: 'include',
            })
            .then(response => {
                return response.json().then(json => {
                    if (response.ok) return json.records;
                    throw json.Message;
                });
            });
        }
        return fetch(url, {
            method,
            body: JSON.stringify(values),
            headers: {
                'Content-Type': 'application/json', //'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
            },
            credentials: 'include',
        }).then((result) => {
            if (result.ok) {
                return result.text().then((text) => text && JSON.parse(text));
            }
            return result.json().then((json) => {
                throw json.Message;
            });
        });

    }

    const onExporting = (e) => {
        OParameters.methods.exportDataGridToPdfExcel(e, title)
    }

    const onClosePopupEmit = () => {
      //console.log('onClosePopupEmit')
        isPopupVisible.value = false;
        dataGrid.value?.instance?.refresh();
    }

    function calculateCellValue(data) {
        //console.log(data)
        const formatter = new Intl.NumberFormat('en-US', {
            style: 'decimal',
            maximumFractionDigits: 2,
            minimumFractionDigits: 2,
        })
        const rounded = formatter.format((data.sum_collected_amount / data.sum_collected_amount_last_year - 1) * 100)
        return rounded + '%';
    }

    function calculateAppointmentsCellValue(data) {
        //console.log(data)
        const formatter = new Intl.NumberFormat('en-US', {
            style: 'decimal',
            maximumFractionDigits: 2,
            minimumFractionDigits: 2,
        })
        const rounded = formatter.format((data.count_appointments / data.count_appointments_last_year - 1) * 100)
        return rounded + '%';
    }

    function onCellPrepared(e) {
        if (e.rowType === "data") {
            if (e.column.dataField === "diff_total_collected_pcnt") {
              //console.log('e.data.sum_collected_amount > e.data.sum_collected_amount_last_year', e.data.sum_collected_amount, e.data.sum_collected_amount_last_year)
              if (parseFloat(e.data.sum_collected_amount) > parseFloat(e.data.sum_collected_amount_last_year)) {
                console.log('green')
                e.cellElement.style.cssText = "color: white; background-color: green; text-align: right;";
              } else {
                console.log('red')
                e.cellElement.style.cssText = "color: white; background-color: red; text-align: right;";
              }
            }

            if (e.column.dataField === "diff_appointments_pcnt") {
              console.log('e.data.count_appointments > e.data.count_appointments_last_year', e.data.count_appointments, e.data.count_appointments_last_year)
              if (parseFloat(e.data.count_appointments) > parseFloat(e.data.count_appointments_last_year)) {
                console.log('green')
                e.cellElement.style.cssText = "color: white; background-color: green; text-align: right;";
              } else {
                console.log('red')
                e.cellElement.style.cssText = "color: white; background-color: red; text-align: right;";
              }
            }
        }
    }

    // Lifecycle hooks
    onMounted(() => {
    })

</script>
<style lang="scss">
</style>
